document.addEventListener('click', function (event) {
  const openBtn = event.target.closest('[data-custom-modal-open]');
  const closeBtn = event.target.closest('[data-custom-modal-close]');

  if (openBtn) {
    const modalId = openBtn.getAttribute('data-custom-modal-open');
    const modal = document.getElementById(modalId);
    if (!modal) return;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('custom-modal-open');

    const panel = modal.querySelector('.custom-modal__panel');
    if (panel) {
      setTimeout(function () {
        panel.focus();
      }, 0);
    }
  }

  if (closeBtn) {
    const modalId = closeBtn.getAttribute('data-custom-modal-close');
    const modal = document.getElementById(modalId);
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('custom-modal-open');

    const opener = document.querySelector('[data-custom-modal-open="' + modalId + '"]');
    if (opener) opener.focus();
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  const openModal = document.querySelector('.custom-modal.is-open');
  if (!openModal) return;

  openModal.classList.remove('is-open');
  openModal.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('custom-modal-open');

  const opener = document.querySelector('[data-custom-modal-open="' + openModal.id + '"]');
  if (opener) opener.focus();
});